import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { ReportSettings } from "@/data/models/Settings";
import { createDefaultReportSettings } from "@/data/models/Client";

const name = "reportSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ReportSettingsVuexModule extends VuexModule {
  reportSettings: ReportSettings = createDefaultReportSettings();

  @Mutation
  setReportSettings(reportSettings: ReportSettings) {
    this.reportSettings = reportSettings;
  }

  @Mutation
  clear() {
    this.reportSettings = createDefaultReportSettings();
  }
}

export const ReportSettingsModule = getModule(ReportSettingsVuexModule, store);
